export const FindFlightById = (flights, flightId) => {
  return flights.find((flight) => flight.id === flightId);
};
